import React from "react";
import {
  Image,
  Linking,
  ScrollView,
  StyleSheet,
  TouchableNativeFeedback,
  TouchableOpacity,
  View,
} from "react-native";
import Text from "@components/CustomText";
import AppText from "@components/AppText";
import WhatsAppIcon from "@assets/svg/WhatsappSmall";
import WAShareOrder from "@components/WAShareOrder";
import colors from "@constants/color";
import metrics from "@constants/metrics";
import OrderStatus from "@assets/svg/OrderStatus";
import StarChecked from "@assets/svg/StarChecked";
import { RatingMapping } from "@components/RateOrderScreen";

import t from "@constants/localization";

const PATH = "screens/SupportTree/components/OrderList/View/OrderCard";

// const { width } = Dimensions.get("window");
export const showLimitedImages = (imgs = [], limit = 3) => {
  if (!imgs.length || limit <= 0) {
    return;
  }
  const totalImages = imgs.length;
  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <>
      {toShowOnlyArr.map((imageUrl, imageIndex) => (
        <Image
          resizeMode="contain"
          key={imageIndex}
          source={{ uri: imageUrl }}
          style={styles.image}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text variant="body_text_4" style={{ color: "rgba(0,0,0,0.56)" }}>
            +{+totalImages - limit}
          </Text>
        </View>
      )}
    </>
  );
};

const OrderCard = (props) => {
  const { item = {}, showUserName = true, showPhone = true } = props;
  const {
    order_id = "",
    created_at = "",
    num_items = 1,
    num_quantity = 1,
    images = [],
    itemLists = [],
    user_name = "",
    user_phone = "",
    payable_amount = "",
    payment_mode = "",
    user_address = "",
    share_message = "",
    order_rating = null,
    order_level = 0,
  } = item;

  const shouldAskForRating = order_level === 4;
  const order_status = itemLists[0].item_list_status;
  const order_status_icon = itemLists[0].item_list_status_icon;
  const order_status_color = itemLists[0].item_list_status_color;

  return (
    <View
      style={[
        styles.orderCardContainer,
        {
          borderRadius: showUserName ? 0 : 10,
          paddingBottom: 15,
          paddingHorizontal: 25,
        },
      ]}
    >
      <View style={styles.topContainer}>
        <View style={styles.orderIdContainer}>
          <Text
            style={{
              fontSize: 14,
              color: colors.lightBlack,
              fontFamily: "NotoSansDevanagari-Regular",
            }}
          >
            {t(`${PATH}/orderNumber`)}
            <Text
              style={{
                fontSize: 14,
                fontFamily: "NotoSansDevanagari-Bold",
                color: "black",
              }}
            >{`${order_id}`}</Text>
          </Text>
        </View>
        <View style={{ alignItems: "flex-end" }}>
          <Text
            style={{
              fontSize: 14,
              color: colors.lightBlack,
              fontFamily: "NotoSansDevanagari-Regular",
            }}
          >
            {t(`${PATH}/orderDate`)}
          </Text>
        </View>
      </View>

      <View
        style={{
          margin: 0,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          borderBottomWidth: 1,
          borderBottomColor: "rgba(0,0,0,0.1)",
          paddingBottom: 5,
          marginBottom: 3,
        }}
      >
        <Text
          style={{
            fontSize: 12,
            color: colors.lightBlack,
            fontFamily: "NotoSansDevanagari-Regular",
          }}
        >
          {num_items} {t(`${PATH}/items`)} • {num_quantity}{" "}
          {t(`${PATH}/quantity`)}
        </Text>
        <Text
          style={{
            fontSize: 12,
            color: "black",
            fontFamily: "NotoSansDevanagari-Regular",
          }}
        >
          {`${created_at.trim()}`}
        </Text>
      </View>
      <ScrollView horizontal contentContainerStyle={styles.imageContainer}>
        {images.length > 0
          ? showLimitedImages(images, 4)
          : showLimitedImages(
              itemLists[0].items.map((el) => el.product_image),
              4,
            )}
      </ScrollView>
      {showUserName && (
        <View style={styles.namePriceContainer}>
          <Text style={styles.namePriceText}>{user_name}</Text>
          <Text style={styles.namePriceText}>
            {payable_amount > 0 ? `₹${parseInt(payable_amount, 10)}` : ""}
          </Text>
        </View>
      )}

      {showPhone && (
        <View style={styles.phonePaymentContainer}>
          <TouchableOpacity
            onPress={() =>
              Linking.openURL(`whatsapp://send?phone=+91${user_phone}`)
            }
          >
            <View>
              <Text
                style={{
                  color: colors.mediumBlack,
                  fontSize: 12,
                  lineHeight: 16,
                  fontFamily: "NotoSansDevanagari-Regular",
                }}
              >
                +91 - {user_phone}
              </Text>
            </View>
          </TouchableOpacity>
          <View>
            <Text
              style={{
                color: "rgba(0, 0, 0, 0.56)",
                fontFamily: "NotoSansDevanagari-Regular",
                fontSize: 12,
                lineHeight: 16,
              }}
            >
              {+payable_amount > 0 ? payment_mode : ""}
            </Text>
          </View>
        </View>
      )}

      <View style={styles.deliveryContainer}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            marginTop: 10,
          }}
        >
          <OrderStatus
            orderStatus={order_status_icon}
            style={{ marginRight: 6 }}
          />
          <Text
            style={{
              color: order_status_color,
              flex: 1,
              fontFamily: "NotoSansDevanagari-SemiBold",
              marginTop: 6,
            }}
          >
            {order_status}
          </Text>
        </View>
      </View>

      {user_address && (
        <View style={{ width: "90%", flexDirection: "row" }}>
          <Text
            style={{
              lineHeight: 16,
              fontSize: 12,
              color: "rgba(0, 0, 0, 0.56)",
              fontFamily: "NotoSansDevanagari-Regular",
            }}
          >
            {user_address}
          </Text>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  orderCardContainer: {
    // backgroundColor: "red",
    flexDirection: "column",
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginVertical: 5,

    backgroundColor: colors.white,
  },
  orderIdContainer: {
    flex: 1,
    flexDirection: "row",
    alignItems: "center",
  },
  topContainer: {
    // backgroundColor: "pink",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  imageContainer: {
    height: 70,
    overflow: "visible",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  image: {
    marginRight: 15,
    height: 50,
    width: 50,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
  },
  nMoreBox: {
    height: 80,
    alignItems: "center",
    justifyContent: "center",
  },
  namePriceContainer: {
    // backgroundColor: "teal",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  whatsappContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  namePriceText: {
    fontSize: 15,
    fontFamily: "NotoSansDevanagari-Bold",
    color: colors.mediumBlack,
  },
  phonePaymentContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 5,
  },
  deliveryContainer: {
    flex: 1,
    paddingBottom: 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  dotContainer: {
    height: 8,
    width: 8,
    backgroundColor: colors.lightBlack,
    borderRadius: 4,
    marginRight: 5,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  waShareButton: {
    width: metrics.screenWidth * 0.1,
    marginRight: 10,
  },
  buttonsContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 15,
  },
  waContainer: {
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.mediumBlack,
    paddingVertical: 8,
    alignItems: "center",
    justifyContent: "center",
  },
  groupBuyOrderContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
});

export default OrderCard;
